import React, { Component } from 'react';
import { connect } from 'react-redux';
import Grid from 'screens/components/basic/Grid';
import TextInput from 'screens/components/basic/TextInput';
import Button from 'screens/components/basic/Button';
import { getOnlineOrderDetailsByCode, getOnlineOrdersQueue, cancelOnlineOrder } from 'actions/EntityActions';
import { showSnackbar } from 'actions/CommonActions';
import LOOKUP from 'constants/lookup';
import { OnlineOrderStatus } from 'constants/enums';
import './styles/buddiOrderSearch.css';
import WithRouter from 'custom/withRouter';

const orderType = 'buddi';

class BuddiOrderSearch extends Component {

    constructor(props, context) {
        super(props, context);
    }

    componentDidMount() {
        this.props.getOnlineOrdersQueue({
            branchId: this.props.branchId,
            code: this.props.orderCode || 0,
            type: orderType
        });
    }

    componentWillReceiveProps(newProps) {
        if (newProps.onlineOrderStatusUpdated == true && this.props.statusUpdatedTime !== newProps.statusUpdatedTime) {
            this.props.getOnlineOrderDetailsByCode({
                branchId: this.props.branchId,
                code: this.props.orderCode,
                type: orderType
            });
        }

        if (newProps.cancelOnlineOrderTime != null && newProps.cancelOnlineOrderTime != undefined && newProps.cancelOnlineOrderTime != this.props.cancelOnlineOrderTime) {
            this.props.showSuccess("Cancel Online Order Success");
        }
    }

    search = () => {
        let model = {
            branchId: this.props.branchId,
            code: this.props.orderCode || 0,
            type: orderType
        };
        this.props.getOnlineOrderDetailsByCode(model);
        this.props.getOnlineOrdersQueue(model);
    }

    cancelOnlineOrder = (id) => {
        console.log('i want to cancel online order' + id);
        let model = {
            Id: id,
            Type: orderType,
            BranchId: this.props.branchId,
            Code: this.props.orderCode || 0
        }
        this.props.cancelOnlineOrder(model);
    }

    loadPOSSale = (posSaleId) => {
        this.props.onClose();
        this.props.navigate("/pos/" + posSaleId);
        window.location.reload();
    }

    startPrepare = (id) => {
        this.props.navigate(`/ecommerce/online-orders/prepare/${id}`);
    }

    render() {

        let orderType, orderStatus = null;
        if (this.props.onlineOrder !== null && this.props.onlineOrder !== undefined) {
            orderType = LOOKUP.ecommerce.onlineOrders.orderType.filter(i => i.value == this.props.onlineOrder.type)[0];
            orderStatus = LOOKUP.ecommerce.onlineOrders.orderStatus.filter(i => i.value == this.props.onlineOrder.status)[0];
        }
        const onlineOrders = this.props.onlineOrders;

        return (
            <Grid>
                <div className="row m-0">
                    {
                        (this.props.onlineOrder === null) &&
                        <div className="alert alert-warning">
                            Online Order was not found.
                        </div>
                    }
                    <div className="col-lg-10">
                        <TextInput
                            name="OnlineOrderNumber"
                            fullWidth={true}
                            label="Buddi Order #"
                            floatingLabelText="Buddi Order #"
                            hintText="Buddi Order #"
                            required />
                    </div>
                    <div className="col-lg-2">
                        <Button
                            name="searchButton"
                            className="pull-right searchBtn btnNewBrandPOS"
                            label="SEARCH"
                            primary={true}
                            onTouchTap={() => this.search()}
                        />
                    </div>
                </div>

                <br />

                {
                    (this.props.onlineOrder !== null && this.props.onlineOrder !== undefined && this.props.onlineOrder.id > 0) &&
                    <div className="online-order-container">
                        <p className="online-order-number purpleText">
                            {(orderType !== null && orderType !== undefined) && orderType.text} Order #{this.props.onlineOrder.buddiNumber}
                        </p>

                        <span className={"status-online-order status-" + this.props.onlineOrder.status}>{(orderStatus !== null && orderStatus !== undefined) && orderStatus.text}</span>

                        <p className="online-order-info purpleText">
                            Customer: {(this.props.onlineOrder.member !== null && this.props.onlineOrder.member !== undefined) && this.props.onlineOrder.member.toUpperCase()}<br />
                            Item(s): {(this.props.onlineOrder.products !== null && this.props.onlineOrder.products !== undefined) && this.props.onlineOrder.products.length} product(s) | Total: ${this.props.onlineOrder.total}<br />
                            Created on: {this.props.onlineOrder.createdDateString}
                        </p>

                        {
                            (this.props.onlineOrder.generatedOrderId !== null && this.props.onlineOrder.generatedOrderId !== undefined) &&
                            <p className="online-order-number purpleText">
                                <hr />
                                Generated Order #{this.props.onlineOrder.generatedOrderId}
                            </p>
                        }

                        {
                            (this.props.onlineOrder.generatedOrderId !== null && this.props.onlineOrder.generatedOrderId !== undefined)
                                ?
                                <Button
                                    type="FlatButtonPrimary"
                                    name={"searchOnlineButton"}
                                    fullWidth={true}
                                    className="btn-show-order"
                                    label={'SHOW GENERATED POS ORDER'}
                                    onTouchTap={() => this.loadPOSSale(this.props.onlineOrder.generatedOrderId)}
                                />
                                :
                                <Button
                                    type="FlatButtonPrimary"
                                    name={"searchOnlineButton"}
                                    fullWidth={true}
                                    className="btn-load-create-order btnNewBrandPOS"
                                    label={(this.props.onlineOrder.status === OnlineOrderStatus.Preparing) ? 'FINISH TO PREPARE' : 'START TO PREPARE'}
                                    onTouchTap={() => this.startPrepare(this.props.onlineOrder.id)}
                                />
                        }


                    </div>
                }
                <div className="row m-0">
                    {
                        (onlineOrders !== undefined && onlineOrders !== null) &&
                        onlineOrders.map((order, index) => {
                            return (
                                <div key={index} className="item-online-order">
                                    <div className="col-lg-2 col-sm-2 col-xs-12 col-md-2 order-number">
                                        #{order.buddiNumber}
                                    </div>
                                    <div className="col-lg-3 col-sm-3 col-xs-12 col-md-3" style={{ textAlign: "center" }} >
                                        <div className={"order-type type-" + order.type}>
                                            {LOOKUP.ecommerce.onlineOrders.orderType.filter(i => i.value == order.type)[0].text}
                                        </div>
                                    </div>

                                    <div className="col-lg-1 col-sm-1 col-xs-12 col-md-1 order-number">
                                        {
                                            (order.status == OnlineOrderStatus.Preparing || order.status == OnlineOrderStatus.Created) && !order.paid ?
                                                <Button
                                                    name="CancelButton"
                                                    label="Cancel"
                                                    className="pull-right btn-finish"
                                                    primary={true}
                                                    onTouchTap={() => this.cancelOnlineOrder(order.id)}
                                                />
                                                :
                                                <span className="order-total">
                                                    ${order.total}{order.forDelivery == true ? <div className="delivery-text">Delivery</div> : ''}
                                                </span>
                                        }
                                    </div>
                                    <div className="col-lg-6 col-sm-6 col-xs-12 col-md-6 btn-start">
                                        {
                                            (order.status == OnlineOrderStatus.Preparing) ?
                                                <Button
                                                    name="finishButton"
                                                    label="Finish to Prepare"
                                                    className="pull-right btn-finish"
                                                    primary={true}
                                                    onTouchTap={() => this.startPrepare(order.id)}
                                                />
                                                :
                                                <Button
                                                    name="searchButton"
                                                    label="Start to Prepare"
                                                    className="pull-right btnNewBrandPOS"
                                                    primary={true}
                                                    onTouchTap={() => this.startPrepare(order.id)}
                                                />
                                        }
                                    </div>
                                </div>
                            )
                        })
                    }
                </div>
            </Grid>
        );
    }
}



function mapStateToProps(state) {
    return {
        branchId: state.common.branchId,
        onlineOrder: state.entity.onlineOrder,
        orderCode: state.form.OnlineOrderNumber,
        deviceKeyName: state.common.applicationSettings.deviceKeyName,
        onlineOrderStatusUpdated: state.entity.onlineOrderStatusUpdated,
        statusUpdatedTime: state.entity.statusUpdatedTime,
        cancelOnlineOrderTime: state.entity.cancelOnlineOrderTime,
        onlineOrders: state.entity.onlineOrders || []
    }
}

function mapDispatchToProps(dispatch) {
    return {
        getOnlineOrderDetailsByCode: (model) => dispatch(getOnlineOrderDetailsByCode(model)),
        getOnlineOrdersQueue: (model) => dispatch(getOnlineOrdersQueue(model)),
        cancelOnlineOrder: (model) => dispatch(cancelOnlineOrder(model)),
        showSuccess: (message) => dispatch(showSnackbar(message))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(WithRouter(BuddiOrderSearch));